import type { GatsbyBrowser } from 'gatsby';
import { trackPageview } from './src/lib/analytics';
import { wrapWithLocale } from './src/locales/wrap-page';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  trackPageview(location.pathname);
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = wrapWithLocale;
